import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';

const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'simple-icons:tiktok',
      keepAlive: true,
      order: 6,
      title: 'TIKTOK工具',
    },
    name: 'TiktokToolsBase',
    path: '/tiktok-tools',
    redirect: '/tiktok-tools/analytics/shop',
    children: [
      {
        meta: {
          icon: 'lucide:chart-no-axes-combined',
          order: 1,
          title: '运营分析',
        },
        name: 'TiktokToolsAnalytics',
        path: 'analytics',
        redirect: '/tiktok-tools/analytics/shop',
        children: [
          {
            component: () =>
              import('#/views/market/tiktokOperations/analytics.vue'),
            meta: {
              icon: 'lucide:store',
              keepAlive: true,
              order: 1,
              title: '店铺分析',
            },
            name: 'TiktokShopAnalytics',
            path: 'shop',
            props: { section: 'SHOP' },
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/analytics.vue'),
            meta: {
              icon: 'lucide:package-search',
              keepAlive: true,
              order: 2,
              title: '商品分析',
            },
            name: 'TiktokProductAnalytics',
            path: 'product',
            props: { section: 'PRODUCT' },
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/productAnalyticsDetail.vue'),
            meta: {
              activePath: '/tiktok-tools/analytics/product',
              hideInMenu: true,
              title: '商品分析详细信息',
            },
            name: 'TiktokProductAnalyticsDetail',
            path: 'product/:productId/detail',
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/analytics.vue'),
            meta: {
              icon: 'lucide:rotate-ccw',
              keepAlive: true,
              order: 3,
              title: '售后分析',
            },
            name: 'TiktokAftersalesAnalytics',
            path: 'aftersales',
            props: { section: 'AFTERSALES' },
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/analytics.vue'),
            meta: {
              hideInMenu: true,
              keepAlive: true,
              title: '订单分析',
            },
            name: 'TiktokOrderAnalyticsLegacy',
            path: 'order',
            props: { section: 'ORDER' },
          },
        ],
      },
      {
        component: () =>
          import('#/views/market/tiktokOperations/productManagement.vue'),
        meta: {
          icon: 'lucide:boxes',
          keepAlive: true,
          order: 2,
          title: '商品管理',
        },
        name: 'TiktokProductManagement',
        path: 'product-center',
      },
      {
        meta: {
          icon: 'lucide:package-plus',
          order: 3,
          title: '发布助手',
        },
        name: 'TiktokPublishingAssistant',
        path: 'publishing-assistant',
        redirect: '/tiktok-tools/publishing-assistant/product-workbench',
        children: [
          {
            component: () =>
              import('#/views/market/tiktokOperations/productWorkbench.vue'),
            meta: {
              icon: 'lucide:files',
              order: 0,
              title: '发品中心',
              stablePageInstance: true,
            },
            name: 'TiktokProductWorkbench',
            path: 'product-workbench',
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/productWorkbench.vue'),
            meta: {
              activePath:
                '/tiktok-tools/publishing-assistant/product-workbench',
              hideInMenu: true,
              title: '商品内容审核',
            },
            name: 'TiktokProductWorkbenchDetail',
            path: 'product-workbench/detail',
          },
          {
            meta: {
              hideInMenu: true,
              activePath: '/tiktok-tools/publishing-assistant/publish-records',
              title: '发布记录（旧地址）',
            },
            name: 'TiktokPublicDraftRecords',
            path: 'public-draft-records',
            redirect: (to) => ({
              path: '/tiktok-tools/publishing-assistant/publish-records',
              query: { ...to.query, source: 'PUBLIC_DRAFT' },
              hash: to.hash,
            }),
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/productCreate.vue'),
            meta: {
              icon: 'lucide:file-plus-2',
              hideInMenu: true,
              keepAlive: true,
              order: 1,
              activePath:
                '/tiktok-tools/publishing-assistant/product-workbench',
              title: '商品上架（兼容入口）',
            },
            name: 'TiktokProductCreate',
            path: 'product-listing',
          },
          {
            meta: {
              icon: 'lucide:history',
              hideInMenu: true,
              keepAlive: true,
              order: 2,
              activePath:
                '/tiktok-tools/publishing-assistant/product-workbench',
              title: '发布记录（兼容入口）',
            },
            name: 'TiktokProductPublishRecords',
            path: 'publish-records',
            redirect: (to) => ({
              path: '/tiktok-tools/publishing-assistant/product-workbench',
              query: { ...to.query, view: 'results' },
              hash: to.hash,
            }),
          },
        ],
      },
      {
        meta: {
          activePath: '/tiktok-tools/publishing-assistant/product-listing',
          hideInMenu: true,
          title: '商品上架（旧地址）',
        },
        name: 'TiktokProductCreateOldPath',
        path: 'product-listing',
        redirect: '/tiktok-tools/publishing-assistant/product-listing',
      },
      {
        meta: {
          activePath: '/tiktok-tools/publishing-assistant/product-listing',
          hideInMenu: true,
          title: '发布新商品（旧地址）',
        },
        name: 'TiktokProductCreateLegacy',
        path: 'product-center/create',
        redirect: '/tiktok-tools/publishing-assistant/product-listing',
      },
      {
        component: () => import('#/views/market/opportunityCenter/index.vue'),
        meta: {
          icon: 'lucide:target',
          keepAlive: true,
          order: 4,
          title: '商品机会',
        },
        name: 'TiktokOpportunity',
        path: 'opportunity',
      },
      {
        meta: {
          icon: 'lucide:badge-percent',
          order: 5,
          title: '营销管理',
        },
        name: 'TiktokToolsMarketing',
        path: 'marketing',
        redirect: '/tiktok-tools/marketing/product-discount',
        children: [
          {
            component: () =>
              import('#/views/market/tiktokOperations/marketing.vue'),
            meta: {
              icon: 'lucide:badge-percent',
              keepAlive: true,
              order: 1,
              title: '单品折扣',
            },
            name: 'TiktokProductDiscount',
            path: 'product-discount',
            props: { section: 'DISCOUNT' },
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/flashSale.vue'),
            meta: {
              icon: 'lucide:timer',
              keepAlive: true,
              order: 2,
              title: '限时秒杀',
            },
            name: 'TiktokFlashSale',
            path: 'flash-sale',
          },
          {
            component: () =>
              import('#/views/market/tiktokOperations/marketing.vue'),
            meta: {
              hideInMenu: true,
              keepAlive: true,
              title: '优惠券',
            },
            name: 'TiktokCouponLegacy',
            path: 'coupon',
            props: { section: 'COUPON' },
          },
        ],
      },
      {
        component: () =>
          import('#/views/market/tiktokOperations/bestsellers.vue'),
        meta: {
          icon: 'lucide:flame',
          keepAlive: true,
          order: 6,
          title: '热卖榜单',
        },
        name: 'TiktokBestsellers',
        path: 'bestsellers',
      },
    ],
  },
];

export default routes;
